/**
 * Agenda `callback` para quando o navegador estiver ocioso (ou num timeout
 * curto, onde não há `requestIdleCallback`, como no Safari). Devolve o
 * cancelamento, para usar direto como retorno de `useEffect`.
 */
export function runWhenIdle(
  callback: () => void,
  timeoutMs = 2000
): () => void {
  if (typeof window.requestIdleCallback === "function") {
    const id = window.requestIdleCallback(callback, { timeout: timeoutMs });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(callback, 200);
  return () => window.clearTimeout(id);
}
